import React from "react";
import "./App.css";
import AppRoutes from './routes';

const App = () => {
	return (
		<div className="app--main--container">
			<AppRoutes />
		</div>
	);
};

export default App;
